import { ImageButton } from '../../components/button/image.button';
import { MaterialIcon } from '../../components/icon/icons';
import { Spinner } from '../../components/spinner/spinner';
import { addStyles, DefaultTheme, rgba } from '../../components/theme';
import { ColorPaletteOrange } from '../../components/theme.palette';
import { T } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { IkePageName } from '../../page/page';

const CSS = {
	container: 'c-TopologicalEditorToolbar',
	title: 'c-TopologicalEditorToolbarTitle',
	buttons: 'c-TopologicalEditorToolbarButtons',
	save: 'c-ButtonSaveAll',
};

const Style = {
	[CSS.container]: {
		padding: DefaultTheme.space(2),
		backgroundColor: rgba(ColorPaletteOrange.C100),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		fontSize: '120%',
		minHeight: DefaultTheme.space(10),
		overflow: 'hidden',
	},
	[CSS.save]: {
		color: DefaultTheme.color.accent,
	},
	[CSS.title]: {
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
	},
	// Centred for the same reason as the collection toolbar's tools row.
	[CSS.buttons]: {
		display: 'flex',
		alignItems: 'center',
	},
};

addStyles(Style);

interface ITopologicalEditorToolbarSaveButton {
	disabled: boolean;
	onClick?: (event?: MouseEvent) => void;
	isSaving?: boolean;
}

interface ITopologicalEditorToolbarPrintButton {
	onClick: (event?: MouseEvent) => void;
}

export interface ITopologicalEditorToolbarOptions {
	title: string;
	selectedCollectionData?: {
		onClick: (event?: MouseEvent) => void;
	};
	saveButton?: ITopologicalEditorToolbarSaveButton;
	printButton?: ITopologicalEditorToolbarPrintButton;
	/** Rendered by the page rather than built here, so this module stays free of collapse state. */
	collapseToggle?: MithrilVNode;
}

export const TopologicalEditorToolbar = {
	saveButton(button: ITopologicalEditorToolbarSaveButton) {
		if (button.isSaving) {
			return Spinner.view();
		}
		return ImageButton.view(MaterialIcon.DONE_ALL, {
			className: CSS.save,
			title: T.TOPO_SAVE_JOB,
			disabled: button.disabled,
			onclick: button.onClick,
		});
	},

	returnButton(onClick: (event?: MouseEvent) => void) {
		return ImageButton.view(MaterialIcon.PHOTO_MEASURE, {
			title: T.LINK_PHOTOMEASURE,
			href: IkePageName.collectionMeasure,
			flip: true,
			disabled: false,
			onclick: onClick,
		});
	},

	printButton(button: ITopologicalEditorToolbarPrintButton) {
		return ImageButton.view(MaterialIcon.PRINT, {
			title: T.TOPO_PRINT_MAP,
			disabled: false,
			onclick: button.onClick,
		});
	},

	view(opts: ITopologicalEditorToolbarOptions) {
		return m(
			'header',
			{
				className: CSS.container,
			},
			[
				m('div', { className: CSS.title, title: opts.title }, opts.title),
				m('div', { className: CSS.buttons }, [
					opts.printButton ? this.printButton(opts.printButton) : null,
					opts.selectedCollectionData ? this.returnButton(opts.selectedCollectionData.onClick) : null,
					opts.saveButton ? this.saveButton(opts.saveButton) : null,
					opts.collapseToggle ?? null,
				]),
			]
		);
	},
};
